import makeApiCall from "../master/axiosIndex";
const STATIC_FILES_DATA = [
  {
    order: 0,
    module: "Payment",
    moduleFileType: "signature.png",
  }
];

const paymentApis = {
  createPayment: (data: any) =>
    makeApiCall({
      url: "/ra-bill/payment/create",
      method: "post",
      data,
    }),
  listPayment: (params: any) =>
    makeApiCall({
      url: "/ra-bill/payments/list",
      method: "get",
      params,
    }),
  paymentById: (paymentId: any) =>
    makeApiCall({
      url: `/ra-bill/payments/id/${paymentId}`,
      method: "get",
    }),
  listReleaseRetention: (params: any) =>
    makeApiCall({
      url: "/work-order/pending-retention-onhold-orders",
      method: "get",
      params,
    }),
  listReleaseOnHold: (params: any) =>
    makeApiCall({
      url: "/work-order/pending-retention-onhold-orders",
      method: "get",
      params,
    }),
  approvalAction: (paymentData: any, files: File[] = []): Promise<any> => {
    const formData = new FormData();
    const filesDataArray = Array.isArray(STATIC_FILES_DATA) ? STATIC_FILES_DATA : [STATIC_FILES_DATA];

    const paymentPayload = {
      ...paymentData,
      filesData: filesDataArray,
    };

    formData.append("payment", JSON.stringify(paymentPayload));

    files.forEach((file) => {
      formData.append("files", file);
    });

    return makeApiCall({
      url: "/ra-bill/payment/approval-action",
      method: "post",
      data: formData,
    });
  },
  bulkUploadPayment: (formData: FormData) =>
    makeApiCall({
      url: "/ra-bill/payment/bulk-upload",
      method: "post",
      data: formData,
      // headers: {
      //   "Content-Type": "multipart/form-data",
      // },
    }),
};

export default paymentApis;
